/** Game mode. Summoner's Rift has bans; ARAM does not. */
export type Mode = 'sr' | 'aram';

export const TEAM_SIZE = 5;
export const BAN_COUNT = 10; // 5 bans per team
